
/**
 * Simple utility to reduce boilerplate.
**/
const createReducer = (initialState, handlers) => {
  const defaultHandler = state => state;

  return (state = initialState, action) => {
    if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
      return (handlers[action.type] || handlers.default || defaultHandler)(state, action);
    }

    return state;
  };
};

export default createReducer;



// WEBPACK FOOTER //
// ./src/universal/utils/createReducer.js